import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_accents_decorative: FaireCategoryEntity = {
  token: "cat_accents-decorative",
  type: "category",
  name: "Decorative objects",
  level: 3,
  parentToken: "cat_home-decor-accents",
  href: "/category/home-decor/home-accents/decorative-objects",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
